import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/clear-input.svg'
import _imports_1 from '@/assets/tick.svg'
import _imports_2 from '@/assets/view.svg'
import _imports_3 from '@/assets/private.svg'


const _withScopeId = n => (_pushScopeId("data-v-05ad5427"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "new-account__h1" }
const _hoisted_3 = { class: "container__main-paragraph" }
const _hoisted_4 = {
  key: 0,
  class: "onboarding-information-overlay"
}
const _hoisted_5 = { class: "onboarding-information-welcome" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 0,
  class: "new-account__h1"
}
const _hoisted_12 = {
  key: 1,
  class: "row"
}
const _hoisted_13 = { class: "new-account__question" }
const _hoisted_14 = { class: "field--poland-tax-residence-field__radios new-account__radios" }
const _hoisted_15 = {
  key: 2,
  class: "row"
}
const _hoisted_16 = { class: "new-account__question" }
const _hoisted_17 = { class: "row custom-select-wrapper" }
const _hoisted_18 = { class: "new-account__prohibited-warning" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "new-account__question" }
const _hoisted_22 = { class: "field--poland-tax-residence-field__radios new-account__radios" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "row" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  ref: "confirmEmail",
  class: "row confirm-email"
}
const _hoisted_28 = { class: "row confirm-email" }
const _hoisted_29 = {
  key: 1,
  class: "button confirm-email__btn confirm-email__btn--confirmed"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "row" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = { class: "row row--information-password" }
const _hoisted_38 = { class: "row row--password-indicators" }
const _hoisted_39 = { class: "row row--password-strength-text" }
const _hoisted_40 = { class: "row row--with-password-strength" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "middle-pipe" }, null, -1))
const _hoisted_42 = { class: "row row--with-agreement" }
const _hoisted_43 = { class: "row__data-regulations" }
const _hoisted_44 = { class: "row__privacy-policy" }
const _hoisted_45 = { class: "row__data-information" }
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "row__privacy-policy" }
const _hoisted_48 = ["href"]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-required" }, "*", -1))
const _hoisted_50 = { class: "data-information__text" }
const _hoisted_51 = { class: "row__marketing_checkboxes" }
const _hoisted_52 = { class: "row__privacy-policy" }
const _hoisted_53 = { class: "row__privacy-policy" }
const _hoisted_54 = { class: "row row__rodo" }
const _hoisted_55 = {
  key: 1,
  class: "cookies-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RodoInformation = _resolveComponent("RodoInformation")!
  const _component_UkraineResidenceInfo = _resolveComponent("UkraineResidenceInfo")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_UkraineResidencePopup = _resolveComponent("UkraineResidencePopup")!
  const _component_Radio = _resolveComponent("Radio")!
  const _component_TheCountrySelect = _resolveComponent("TheCountrySelect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_FillableBullet = _resolveComponent("FillableBullet")!
  const _component_CheckBox = _resolveComponent("CheckBox")!
  const _component_RecaptchaButton = _resolveComponent("RecaptchaButton")!
  const _component_Cookies = _resolveComponent("Cookies")!

  return (_openBlock(), _createElementBlock("div", {
    "data-testid": "step-newAccount",
    class: _normalizeClass(["container new-account", _ctx.isOpenOverlay ? 'first-step' : ''])
  }, [
    _createVNode(_component_RodoInformation, {
      "is-open": _ctx.isRodoInformationOpen,
      onClose: _ctx.handleModal
    }, null, 8, ["is-open", "onClose"]),
    _createVNode(_component_UkraineResidenceInfo, {
      "is-open": _ctx.isUkraineResidenceInfoOpen,
      onClose: _ctx.handleUkraineResidenceInfoOpen
    }, null, 8, ["is-open", "onClose"]),
    (
                !_ctx.isOpenOverlay &&
                _ctx.isConfirmResidence &&
                !_ctx.isChooselanguageRequired
            )
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.createNewAccount`)), 1),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.alreadyHaveAccount`)), 1),
            _createVNode(_component_router_link, {
              to: "/login",
              onClick: _cache[0] || (_cache[0] = () => _ctx.handleClick())
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.logInToYourAccount`)), 1)
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("form", {
      onSubmit: _cache[25] || (_cache[25] = _withModifiers(() => {}, ["prevent"]))
    }, [
      (_ctx.isOpenOverlay)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _withDirectives(_createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                class: "onboarding-information-overlay__short-information",
                innerHTML: _ctx.$t(`${_ctx.TRANSLATION_KEY}.beReadyHookHeader`)
              }, null, 8, _hoisted_6),
              _createElementVNode("div", {
                class: "onboarding-information-overlay__short-information",
                innerHTML: _ctx.$t(`${_ctx.TRANSLATION_KEY}.beReadyHook`)
              }, null, 8, _hoisted_7),
              _withDirectives(_createElementVNode("div", null, [
                _createElementVNode("img", {
                  src: _ctx.getMobilePoster(),
                  class: "samsung-mobile",
                  alt: ""
                }, null, 8, _hoisted_8)
              ], 512), [
                [_vShow, _ctx.isSamsung]
              ]),
              _withDirectives(_createElementVNode("div", null, [
                (_ctx.isMobile)
                  ? (_openBlock(), _createElementBlock("video", {
                      key: 0,
                      ref: "videoEl",
                      muted: "",
                      playsinline: "",
                      src: _ctx.videoMobileUrl,
                      onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleVideoError && _ctx.handleVideoError(...args)))
                    }, null, 40, _hoisted_9))
                  : (_openBlock(), _createElementBlock("video", {
                      key: 1,
                      ref: "videoEl",
                      muted: "",
                      playsinline: "",
                      src: _ctx.videoDesktopUrl,
                      onError: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleVideoError && _ctx.handleVideoError(...args)))
                    }, null, 40, _hoisted_10))
              ], 512), [
                [_vShow, !_ctx.isSamsung]
              ])
            ], 512), [
              [_vShow, !_ctx.showUaPopup]
            ]),
            _withDirectives(_createElementVNode("div", null, [
              _withDirectives(_createVNode(_component_UkraineResidencePopup, { onYesEuAddress: _ctx.yesEuAddress }, null, 8, ["onYesEuAddress"]), [
                [_vShow, _ctx.showUaPopup]
              ]),
              (!_ctx.isOpenOverlay && !_ctx.isConfirmResidence)
                ? (_openBlock(), _createElementBlock("h1", _hoisted_11, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.countryOfResidenceTitle`)), 1))
                : _createCommentVNode("", true),
              (_ctx.isResidenceConfirmRadioRequired)
                ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.residenceConfirmText`)), 1),
                    _createElementVNode("div", _hoisted_14, [
                      (_ctx.UtilityHelper.getLocale() === _ctx.Locale.UA)
                        ? (_openBlock(), _createBlock(_component_Radio, {
                            key: 0,
                            label: 
                                    _ctx.$t(`${_ctx.TRANSLATION_KEY}.residenceConfirmYes`)
                                ,
                            name: "residenceConfirm",
                            value: true,
                            checked: _ctx.formData.residenceConfirm === true,
                            onUpdateValue: _cache[3] || (_cache[3] = 
                                    ($event) => _ctx.updateResidenceConfirm($event)
                                )
                          }, null, 8, ["label", "checked"]))
                        : (_openBlock(), _createBlock(_component_Radio, {
                            key: 1,
                            label: 
                                    _ctx.$t(`${_ctx.TRANSLATION_KEY}.residenceConfirmYes`)
                                ,
                            name: "residenceConfirm",
                            value: true,
                            checked: _ctx.formData.residenceConfirm === true,
                            onUpdateValue: _cache[4] || (_cache[4] = 
                                    ($event) =>
                                        _ctx.updateResidenceConfirm($event, true)
                                )
                          }, null, 8, ["label", "checked"])),
                      _createVNode(_component_Radio, {
                        label: 
                                    _ctx.$t(`${_ctx.TRANSLATION_KEY}.residenceConfirmNo`)
                                ,
                        name: "residenceConfirm",
                        value: false,
                        "handles-error": false,
                        checked: _ctx.formData.residenceConfirm === false,
                        onUpdateValue: _cache[5] || (_cache[5] = 
                                    ($event) => _ctx.updateResidenceConfirm($event)
                                )
                      }, null, 8, ["label", "checked"])
                    ])
                  ], 512)), [
                    [_vShow, !_ctx.showUaPopup]
                  ])
                : _createCommentVNode("", true),
              (_ctx.isSelectResidenceRequired && !_ctx.showUaPopup)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t(
                                    `${_ctx.TRANSLATION_KEY}.residenceConfirmSelectText`
                                )), 1),
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_TheCountrySelect, {
                        modelValue: _ctx.formData.residenceCountry,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formData.residenceCountry = $event)),
                        name: "residenceCountry",
                        "default-value": _ctx.defaultCountry,
                        "country-list": _ctx.countries,
                        label: 
                                    _ctx.$t(`${_ctx.TRANSLATION_KEY}.countrySelectLabel`)
                                ,
                        placeholder: 
                                    _ctx.$t(
                                        `${_ctx.TRANSLATION_KEY}.countrySelectPlaceholder`
                                    )
                                ,
                        class: "custom-select",
                        onSelectedCountry: _cache[7] || (_cache[7] = 
                                    ($event) =>
                                        (_ctx.formData.residenceCountry = $event)
                                )
                      }, null, 8, ["modelValue", "default-value", "country-list", "label", "placeholder"])
                    ]),
                    _withDirectives(_createElementVNode("div", null, [
                      _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t(
                                        `${_ctx.TRANSLATION_KEY}.prohibitedCountryInfo`
                                    )), 1)
                    ], 512), [
                      [_vShow, _ctx.isProhibitedCountry]
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.showUaPopup)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 3,
                    type: "button",
                    class: "button button--submit",
                    "data-testid": "btn-newAccount-confirmResidence",
                    disabled: 
                            !(
                                _ctx.formData.residenceConfirm ||
                                (_ctx.isSelectResidenceRequired &&
                                    _ctx.formData.residenceCountry &&
                                    !_ctx.isProhibitedCountry)
                            )
                        ,
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleResidenceConfirm && _ctx.handleResidenceConfirm(...args)))
                  }, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.saveAndContinue`)), 9, _hoisted_19))
                : _createCommentVNode("", true)
            ], 512), [
              [_vShow, !_ctx.isChooselanguageRequired]
            ])
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", null, [
        _withDirectives(_createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.getChooseLanguageTextByResidence), 1),
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_Radio, {
                label: 
                                    _ctx.$t(`${_ctx.TRANSLATION_KEY}.chooseLanguageYes`)
                                ,
                name: "chooseLanguage",
                value: true,
                checked: _ctx.formData.chooseLanguage,
                onUpdateValue: _cache[9] || (_cache[9] = 
                                    ($event) =>
                                        (_ctx.formData.chooseLanguage = $event)
                                )
              }, null, 8, ["label", "checked"]),
              _createVNode(_component_Radio, {
                label: 
                                    _ctx.$t(`${_ctx.TRANSLATION_KEY}.chooseLanguageNo`)
                                ,
                name: "chooseLanguage",
                value: false,
                "handles-error": false,
                onUpdateValue: _cache[10] || (_cache[10] = 
                                    ($event) =>
                                        (_ctx.formData.chooseLanguage = $event)
                                )
              }, null, 8, ["label"])
            ]),
            _withDirectives(_createElementVNode("a", {
              class: "button redirect-link",
              href: ""
            }, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.start`)), 513), [
              [_vShow, _ctx.formData.chooseLanguage]
            ]),
            _withDirectives(_createElementVNode("button", {
              type: "button",
              class: "button button--submit",
              disabled: _ctx.formData.chooseLanguage === null,
              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.handleChooseLanguage && _ctx.handleChooseLanguage(...args)))
            }, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.saveAndContinue`)), 9, _hoisted_23), [
              [_vShow, !_ctx.formData.chooseLanguage]
            ])
          ])
        ], 512), [
          [_vShow, _ctx.isChooselanguageRequired]
        ]),
        _withDirectives(_createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_Field, {
              modelValue: _ctx.formData.email,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.formData.email = $event)),
              type: "email",
              name: "email",
              "cy-data": "email",
              placeholder: 
                                _ctx.$t(`${_ctx.TRANSLATION_KEY}.emailPlaceholder`)
                            ,
              "allow-all-characters": true,
              onInput: _ctx.validateEmail,
              onKeydown: _withKeys(_withModifiers(_ctx.handleEmailEnter, ["prevent"]), ["enter"])
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.email`)), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder", "onInput", "onKeydown"]),
            _createElementVNode("button", {
              type: "button",
              class: "input-icon",
              "aria-label": "Clear email",
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.clearInput && _ctx.clearInput(...args)))
            }, _hoisted_26)
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.confirmEmailLabel`)), 1),
            _createVNode(_component_Field, {
              modelValue: _ctx.formData.email,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.formData.email = $event)),
              type: "email",
              name: "confirmEmail",
              "cy-data": "confirm-email",
              placeholder: 
                                _ctx.$t(`${_ctx.TRANSLATION_KEY}.emailPlaceholder`)
                            ,
              "disable-paste": true,
              disabled: true,
              class: _normalizeClass(_ctx.isEmailConfirmed ? 'confirmed' : ''),
              "allow-all-characters": true,
              onInput: _ctx.validateEmail
            }, null, 8, ["modelValue", "placeholder", "class", "onInput"])
          ], 512),
          _createElementVNode("div", _hoisted_28, [
            (!_ctx.isEmailConfirmed)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: _normalizeClass([
                                'confirm-email__btn button',
                                _ctx.isEmailValid ? 'isValid' : 'disabled',
                            ]),
                  "data-testid": "btn-newAccount-confirmEmail",
                  onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.confirmUserEmail && _ctx.confirmUserEmail(...args)))
                }, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.saveAndContinue`)), 3))
              : (_openBlock(), _createElementBlock("span", _hoisted_29, [
                  _hoisted_30,
                  _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.emailIsConfirmed`)), 1)
                ]))
          ]),
          _createVNode(_Transition, {
            name: "fade",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (_ctx.isEmailConfirmed)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(_component_Field, {
                        modelValue: _ctx.formData.password,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.formData.password = $event)),
                        type: _ctx.passwordInputType,
                        name: "password",
                        "cy-data": "password",
                        placeholder: 
                                        _ctx.$t(
                                            `${_ctx.TRANSLATION_KEY}.passwordPlaceholder`
                                        )
                                    ,
                        "allow-all-characters": true,
                        onInput: _ctx.validatePassword
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.password`)), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "type", "placeholder", "onInput"]),
                      _withDirectives(_createElementVNode("button", {
                        type: "button",
                        class: "show-password-icon",
                        "aria-label": "Show password",
                        onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.showPassword(true)))
                      }, _hoisted_34, 512), [
                        [_vShow, _ctx.passwordInputType === 'password']
                      ]),
                      _withDirectives(_createElementVNode("button", {
                        type: "button",
                        class: "show-password-icon",
                        "aria-label": "Hide password",
                        onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.showPassword(false)))
                      }, _hoisted_36, 512), [
                        [_vShow, _ctx.passwordInputType === 'text']
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.passwordInformation`)), 1),
                    _createElementVNode("div", _hoisted_38, [
                      _createVNode(_component_FillableBullet, {
                        class: "fs-11",
                        "is-filled": 
                                        _ctx.validationPass.isContainsEightChars
                                    
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t(
                                            `${_ctx.TRANSLATION_KEY}.passwordRequirementsOne`
                                        )), 1)
                        ]),
                        _: 1
                      }, 8, ["is-filled"]),
                      _createVNode(_component_FillableBullet, {
                        class: "fs-11",
                        "is-filled": _ctx.validationPass.isMixedLetters
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t(
                                            `${_ctx.TRANSLATION_KEY}.passwordRequirementsTwo`
                                        )), 1)
                        ]),
                        _: 1
                      }, 8, ["is-filled"]),
                      _createVNode(_component_FillableBullet, {
                        class: "fs-11",
                        "is-filled": _ctx.validationPass.isContainsNumber
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t(
                                            `${_ctx.TRANSLATION_KEY}.passwordRequirementsThree`
                                        )), 1)
                        ]),
                        _: 1
                      }, 8, ["is-filled"]),
                      _createVNode(_component_FillableBullet, {
                        class: "fs-11",
                        "is-filled": 
                                        _ctx.validationPass.isContainsSpecialCharacter
                                    
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t(
                                            `${_ctx.TRANSLATION_KEY}.passwordRequirementsFour`
                                        )), 1)
                        ]),
                        _: 1
                      }, 8, ["is-filled"])
                    ]),
                    _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.passwordStrength`)), 1),
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", {
                        class: "progress",
                        style: _normalizeStyle({
                                        width:
                                            _ctx.validationPass.passwordProgress +
                                            '%',
                                        background:
                                            _ctx.validationPass.passwordStrength,
                                    })
                      }, null, 4),
                      _hoisted_41
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("div", _hoisted_43, [
                        _createVNode(_component_CheckBox, {
                          modelValue: _ctx.marketingAgreementAll,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.marketingAgreementAll = $event)),
                          name: "marketingAgreementAll",
                          "cy-data": "marketingAgreementAll",
                          value: false,
                          onchange: _ctx.handleToggleAll,
                          "no-auto-validation": true
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.$t(
                                                `${_ctx.TRANSLATION_KEY}.marketingCheckBoxAcceptAll`
                                            )), 1)
                          ]),
                          _: 1
                        }, 8, ["modelValue", "onchange"])
                      ]),
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                          _createVNode(_component_CheckBox, {
                            modelValue: 
                                                _ctx.formData.marketingAgreement
                                            ,
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (
                                                _ctx.formData.marketingAgreement
                                             = $event)),
                            name: "marketingAgreement",
                            "cy-data": "marketingAgreement",
                            value: false,
                            "input-size": _ctx.CheckboxSize.Medium
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_47, [
                                _createTextVNode(_toDisplayString(_ctx.$t(
                                                        `${_ctx.TRANSLATION_KEY}.termsAndConditionsOne`
                                                    )) + " ", 1),
                                _createElementVNode("a", {
                                  class: "terms-link",
                                  href: 
                                                        _ctx.$t(
                                                            `${_ctx.TRANSLATION_KEY}.termsAndConditionsLink`
                                                        )
                                                    ,
                                  target: "_blank"
                                }, _toDisplayString(_ctx.$t(
                                                            `${_ctx.TRANSLATION_KEY}.termsAndConditionsTwo`
                                                        )), 9, _hoisted_48),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t(
                                                        `${_ctx.TRANSLATION_KEY}.termsAndConditionsThree`
                                                    )) + " ", 1),
                                _hoisted_49
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue", "input-size"])
                        ]),
                        _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.$t(
                                                `${_ctx.TRANSLATION_KEY}.marketingCheckboxTitle`
                                            )), 1),
                        _createElementVNode("div", _hoisted_51, [
                          _createVNode(_component_CheckBox, {
                            modelValue: 
                                                _ctx.formData.marketingAgreementEmail
                                            ,
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (
                                                _ctx.formData.marketingAgreementEmail
                                             = $event)),
                            name: "marketingAgreementEmail",
                            "cy-data": "marketingAgreementEmail",
                            value: false,
                            "input-size": _ctx.CheckboxSize.Medium
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.$t(
                                                    `${_ctx.TRANSLATION_KEY}.marketingCheckboxEmail`
                                                )), 1)
                            ]),
                            _: 1
                          }, 8, ["modelValue", "input-size"]),
                          _createVNode(_component_CheckBox, {
                            modelValue: 
                                                _ctx.formData.marketingAgreementSms
                                            ,
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (
                                                _ctx.formData.marketingAgreementSms
                                             = $event)),
                            name: "marketingAgreementSms",
                            "cy-data": "marketingAgreementSms",
                            value: false,
                            "input-size": _ctx.CheckboxSize.Medium
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.$t(
                                                    `${_ctx.TRANSLATION_KEY}.marketingCheckboxSms`
                                                )), 1)
                            ]),
                            _: 1
                          }, 8, ["modelValue", "input-size"])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "link",
                        onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.handleModal && _ctx.handleModal(...args)))
                      }, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.rodoQuestion`)), 1)
                    ]),
                    _createVNode(_component_RecaptchaButton, {
                      action: _ctx.Action.NEW_ACCOUNT,
                      data: _ctx.formData,
                      "button-value": _ctx.$t(`${_ctx.TRANSLATION_KEY}.next`),
                      "data-testid": "btn-newAccont-nextStep",
                      class: "button button--submit",
                      disabled: 
                                    !(
                                        _ctx.emailsMatch &&
                                        _ctx.isEmailValid &&
                                        _ctx.validationPass.isValidPassword &&
                                        _ctx.isEmailConfirmed &&
                                        _ctx.formData.marketingAgreement
                                    )
                                ,
                      onClick: _cache[24] || (_cache[24] = 
                                    () =>
                                        _ctx.amplitudeSendEvent(
                                            _ctx.AmplitudeAnalyticsEvents.newLogin
                                                .PASSWORD_CONTINUE
                                        )
                                )
                    }, null, 8, ["action", "data", "button-value", "disabled"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ], 512), [
          [_vShow, !_ctx.isChooselanguageRequired]
        ])
      ], 512), [
        [_vShow, !_ctx.isOpenOverlay]
      ])
    ], 32),
    (_ctx.isDetectedMobileDevice)
      ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
          _createVNode(_component_Cookies)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}